import { isNumber } from "lodash";
import React, { useState, useEffect} from "react";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";

export default function EventsMap({item,lefletHeightClass}) {
  const [location, setLocation] = useState(null);

  useEffect(() => {

    if(item.location && item.location.coordinates && item.location.coordinates.length && isNumber(item.location.coordinates[0]) && isNumber(item.location.coordinates[1])) {
      const coordinates = item.location.coordinates
       setLocation({
         lat:coordinates[1],
         lng:coordinates[0]
       })
    }

    console.log("chhhh",item)
    
  }, [item])
  
  return (
    <div style={{'width': '100%',display: location && location.lng==0 && location.lat==0 ? "none":"block"}} className={lefletHeightClass ? lefletHeightClass :""}>
      {
        location &&  <Map
        center={location}
        zoom={13}
       
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />


        <Marker key={location.lat} position={location} >
          <Popup>
           {item.eventAddress}
          </Popup>
        </Marker>
      </Map>
      }
     
    </div>
  );
}
